export const AuthConfig = {
  scope: 'openid profile crmdata',
  responseType: 'code',
  codeChallengeMethod: 'S256',
  grantType: 'authorization_code',
  refreshGrantType: 'refresh_token',
  codeVerifierLength: 48,
  acrValues: 'fihclogin',
};
